import type { ReactNode } from 'react';
import { ResizableWorkspace } from '@/components/workspace/ResizableWorkspace';

const STORAGE_KEY = 'mh-leads-detail-width';

export function LeadWorkspaceLayout({
  detailOpen,
  main,
  detail,
  onDetailDismiss,
}: {
  detailOpen: boolean;
  main: ReactNode;
  detail: ReactNode | null;
  onDetailDismiss?: () => void;
}) {
  return (
    <ResizableWorkspace
      storageKey={STORAGE_KEY}
      detailOpen={detailOpen}
      main={main}
      detail={detail}
      resizerAriaLabel="Breedte leadpaneel aanpassen"
      onDetailDismiss={onDetailDismiss}
    />
  );
}
